@if (showParent) {
  <div class="question-panel">
    @for (item of childrenQuestions; track item; let i = $index) {
      <app-question-toggle-pills
        [question]="item"
        [toggleLabel]="item.question_copy"
        (questionAnswer)="saveValue($event, i)">
      </app-question-toggle-pills>
    }
  </div>
}

@if (!showParent) {
  @for (item of childrenQuestions; track item; let i = $index) {
    <app-question-toggle-pills
      [question]="item"
      [toggleLabel]="item.question_copy"
      (questionAnswer)="saveValue($event, i)">
    </app-question-toggle-pills>
  }
}
